<template>
  <div class="redirect-page">
    <div class="redirect-content">
      <div v-if="errorMessage" class="error-box">
        <h2 class="title">Não foi possível abrir sua Nota Fiscal</h2>
        <p class="subtitle">{{ errorMessage }}</p>

        <div v-if="rawLink" class="raw-link">
          <div class="raw-link__label">Link recebido:</div>
          <div class="raw-link__value">{{ rawLink }}</div>
        </div>

        <div class="help-box">
          <div class="help-box__title">O que fazer agora?</div>
          <div class="help-box__text">
            Entre em contato com o setor Financeiro/Faturamento e solicite um
            novo link da Nota Fiscal.
          </div>
        </div>
      </div>

      <div v-else class="loading-box">
        <h2 class="title">Redirecionando para sua Nota Fiscal...</h2>
        <p class="subtitle">Aguarde um momento.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errorMessage: "",
      rawLink: "",
    };
  },
  methods: {
    normalizeAndValidateUrl(url) {
      if (!url || typeof url !== "string") {
        return "";
      }

      try {
        const formatted = url.trim().startsWith("www.")
          ? `https://${url.trim()}`
          : url.trim();

        const parsed = new URL(formatted);

        return ["http:", "https:"].includes(parsed.protocol) ? parsed.href : "";
      } catch {
        return "";
      }
    },

    mapErrorMessage(error) {
      const status = error.response.status;
      if (status === 403) {
        return "Link inválido ou expirado. Solicite um novo link.";
      }
      if (status === 404) {
        return "Nota não encontrada.";
      }
      return "Não conseguimos validar o link agora. Tente novamente em alguns minutos.";
    },

    async markAsReadAndGetLink(id, token) {
      const payload = await this.$http.get(
        `v2/notas/marcar-lida/${id}?t=${token}`
      );

      return payload.link || "";
    },

    finalizeRedirect(link) {
      this.rawLink = link ? String(link).trim() : "";

      const validDest = this.normalizeAndValidateUrl(this.rawLink);
      if (validDest) {
        window.location.assign(validDest);
      } else {
        this.errorMessage = "O link da Nota Fiscal está inválido.";
      }
    },
  },

  async mounted() {
    const id = this.$route.params.id;
    const token = this.$route.query.t;

    this.$vs.loading();
    try {
      const finalLink = await this.markAsReadAndGetLink(id, token);
      this.finalizeRedirect(finalLink);
    } catch (error) {
      this.errorMessage = this.mapErrorMessage(error);
    } finally {
      this.$vs.loading.close();
    }
  },
};
</script>

<style scoped>
.redirect-page {
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.redirect-content {
  width: 100%;
  max-width: 560px;
  padding: 24px;
  text-align: center;
}

.title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 8px;
}

.subtitle {
  color: #6b7280;
  margin-bottom: 16px;
}

.raw-link {
  margin: 14px 0 18px 0;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  text-align: left;
  background: #fafafa;
}

.raw-link__label {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 6px;
}

.raw-link__value {
  font-size: 13px;
  word-break: break-all;
  color: #111827;
}

.help-box {
  margin-top: 12px;
  padding: 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  text-align: left;
}

.help-box__title {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #111827;
}

.help-box__text {
  font-size: 13px;
  color: #374151;
  line-height: 1.35;
}
</style>
